import React from 'react'
import { CButton, CFormTextarea } from '@coreui/react'
import CopyLogo from '../../assets/copy-logo.svg'
const CopyClipboardTextArea = ({ copyText, css, rows = 3 }) => {
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text)
    } else {
      return document.execCommand('copy', true, text)
    }
  }

  const handleCopyClick = () => {
    copyTextToClipboard(copyText)
      .then(() => {})
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <div className={`position-relative d-flex align-items-center ${css}`}>
      <CFormTextarea rows={rows} type="text" value={copyText} readOnly />

      <CButton
        style={{
          fontSize: '13px',
          background: '#20211c',
          borderColor: 'black',
        }}
        className="  h-fit ml-1 d-flex align-items-center"
        onClick={handleCopyClick}
      >
        Copy
        <img src={CopyLogo} alt="CopyLogo" className="ml-1" />
      </CButton>
    </div>
  )
}

export default CopyClipboardTextArea
